// src/components/AddCandidateForm/AddCandidateForm.js
import React, { useState } from "react";
import { postData } from "../../services/FetchNodeservices";

export default function AddCandidateForm({ job, onClose }) {
  /* -------------------------------------------------------
      READ LOGGED-IN USER DETAILS
  ------------------------------------------------------- */
  const loginUser = JSON.parse(localStorage.getItem("USER"));

  const addedByName = `${loginUser?.first_name || ""} ${
    loginUser?.last_name || ""
  }`.trim();

  const addedById = loginUser?.id || null;

  /* -------------------------------------------------------
      FORM STATE
  ------------------------------------------------------- */
  const [form, setForm] = useState({
    f_name: "",
    l_name: "",
    email_id: "",
    phone_number: "",
    qualification: "",
    experience: "",
    current_company: "",
    designation: "",
    current_ctc: "",
    expected_ctc: "",
    notice_period: "",
    hometown: "",
    confirm_email: "",
    country: "",
    state: "",
    city: "",
    reason_for_change: "", // ⭐ NEW FIELD
    application_date: new Date().toISOString().split("T")[0],
    resume: null,
    status: "New",
    status_color: "blue",

    // REMOVED FIELDS:
    // interview_mode: "",
    // interview_datetime: "",
  });

  const [uploading, setUploading] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [message, setMessage] = useState("");

  /* -------------------------------------------------------
      HANDLE INPUT CHANGE
  ------------------------------------------------------- */
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setForm({ ...form, [name]: files[0] });
      setSelectedFileName(files[0].name);
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  /* -------------------------------------------------------
      SUBMIT CANDIDATE
  ------------------------------------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    setMessage("");

    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // extra data (job & user info)
    formData.append("req_id", job.reqId);
    formData.append("added_by", addedByName);
    formData.append("added_by_id", addedById);

    try {
      const result = await postData("candidate/submit_candidate", formData, true);

      if (result.status) {
        setMessage("✅ Candidate added successfully!");
        setTimeout(onClose, 1500);
      } else {
        setMessage("❌ Error: " + result.message);
      }
    } catch (error) {
      console.error(error);
      setMessage("❌ Upload failed. Try again.");
    }

    setUploading(false);
  };

  /* -------------------------------------------------------
      UI
  ------------------------------------------------------- */
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          width: "90%",
          maxWidth: "650px",
          maxHeight: "90vh",
          overflowY: "auto",
          padding: "24px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            background: "linear-gradient(90deg, #0072ff, #00c6ff)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Add Candidate — {job.title}
        </h2>

        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "12px",
            }}
          >
            {/* BASIC DETAILS */}
            {[
              "f_name",
              "l_name",
              "email_id",
              "phone_number",
              "qualification",
              "experience",
              "current_company",
              "designation",
              "current_ctc",
              "expected_ctc",
              "notice_period",
              "hometown",
              "confirm_email",
              "country",
              "state",
              "city",
            ].map((field) => (
              <input
                key={field}
                type="text"
                name={field}
                value={form[field]}
                onChange={handleChange}
                placeholder={
                  field === "hometown"
                    ? "CURRENT LOCATION"
                    : field.replace(/_/g, " ").toUpperCase()
                }
                style={{
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
                required={["f_name", "l_name", "email_id"].includes(field)}
              />
            ))}

            {/* APPLICATION DATE */}
            <input
              type="date"
              name="application_date"
              value={form.application_date}
              onChange={handleChange}
              style={{ padding: "8px", borderRadius: "6px" }}
            />

            {/* ⭐ NEW: REASON FOR CHANGE */}
            <textarea
              name="reason_for_change"
              placeholder="REASON FOR CHANGE"
              value={form.reason_for_change}
              onChange={handleChange}
              style={{
                gridColumn: "1 / span 2",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                minHeight: "70px",
              }}
            />

            {/* RESUME UPLOAD */}
            <div style={{ gridColumn: "1 / span 2" }}>
              <label>Resume (PDF / DOC / DOCX)</label>
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                required
              />

              {selectedFileName && (
                <p style={{ fontSize: "14px", color: "#444" }}>
                  📄 {selectedFileName}
                </p>
              )}
            </div>
          </div>

          {message && (
            <p
              style={{
                textAlign: "center",
                marginTop: "15px",
                color: message.startsWith("✅") ? "green" : "red",
              }}
            >
              {message}
            </p>
          )}

          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              type="submit"
              disabled={uploading}
              style={{
                background: "linear-gradient(90deg,#00c6ff,#0072ff)",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "6px",
                marginRight: "10px",
              }}
            >
              {uploading ? "Uploading..." : "Save Candidate"}
            </button>

            <button
              type="button"
              onClick={onClose}
              style={{
                background: "#ccc",
                padding: "10px 20px",
                borderRadius: "6px",
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
